import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ListComponent } from '../list.component';
import { JobsDataSource } from '../../datasources/jobs-data-source';

@Component({
  selector: 'app-list-desktop',
  templateUrl: './list-desktop.component.html',
  styleUrls: ['./list-desktop.component.scss']
})
export class ListDesktopComponent extends ListComponent implements OnInit, AfterViewInit, OnDestroy {

  dataSource: JobsDataSource;
  displayedColumns: string[] =
    ['projectName', 'projectNbr', 'customerName', 'bidAmount', 'jobStatus', 'jobType', 'convertedDate', 'startDate', 'salesperson', 'action'];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit(): void {
    this.dataSource = new JobsDataSource(this.jobService);
    this.loadJobs();

    if (this.isFieldTech)
      this.displayedColumns =
        ['projectName', 'projectNbr', 'customerName', 'jobStatus', 'jobType', 'convertedDate', 'startDate', 'salesperson', 'action'];

    super.init();
  }

  ngAfterViewInit(): void {
    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        tap(() => this.loadJobs())
      )
      .subscribe();

    this.paginator.page
      .pipe(
        tap(() => this.loadJobs())
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.sort.sortChange.unsubscribe();
    this.paginator.page.unsubscribe();
  }

  loadJobs() {
    this.dataSource.loadJobs(this.filter, this.sort.active,
      this.sort.direction, this.paginator.pageIndex);
  }

  refreshSummary() {
    this.loadSummary();
    this.loadJobs();
  }

}
